<template>
  <div>
    <v-card>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="elements"
          :items-per-page="5"
          class="elevation-1"
          hide-default-footer
          :disable-pagination="true"
          :loading="loading"
        >
          <template v-slot:item.action="{ item }">
            <v-btn 
              @click="selectItem(item)"
              rounded
               small color="success">
              Select
            </v-btn>
          </template>
        </v-data-table>
        <div class="text-end" style="margin-top: 10px;">
          
          <app-element-selector
            :device="device"
            :page="page"
            @listSubmitted="getDataFromApi"
          ></app-element-selector>
        </div>
        
      </v-card-text>
    </v-card>
    <app-placement-details
      v-if="placementDetailsVisible"
      :device="device"
      :page="page"
      :element="element"
      @pageUpdated="$emit('pageUpdated')"
    >
    </app-placement-details>
  </div>
</template>
<script>
  import axios from 'axios'
  import ElementSelector from './ElementSelector.vue' 
  import PlacementDetails from './placement/PlacementDetails.vue'

  export default {
    props: ['device', 'page'],
    components : {
      AppElementSelector: ElementSelector,
      AppPlacementDetails : PlacementDetails 
    },
    data(){
      return {
        //elementId: '',
        headers: [
          //{text: 'Id', align: 'left', value : 'id'},
          {text: 'Name', align: 'left', value: 'name'},
          {text: 'Type', align: 'left', value: 'type'},
          {text: 'Sizes', align: 'left', value: 'sizes'},
          {text: 'Action', align: 'right', value: 'action'}
        ],
        elements : [],
        loading: false,
      }
    },
    watch:{
      device(){
        this.getDataFromApi()
      }
    },
    computed : {
      element(){
        if(this.elements == []) { return []}
        if(this.$route.query.element == undefined) return []
        const foo = this.elements.findIndex(x => x.name == this.$route.query.element)
        return (foo == -1) ? [] : this.elements[foo]

      },
      placementDetailsVisible(){
        return (this.element.length !== 0)
      }
    },
    mounted(){
      this.getDataFromApi()
    },
    methods: {
      async getDataFromApi(){
        this.placements = []
        this.selectedElements = [];
        this.loading = true
        const request = {
          type : "management/page",
          action : "getElementsTable",
          data : {
            pageId : this.page.id,
            deviceId: this.device.id
          }
        };
        try {
          const accessToken = await this.$auth.getAccessToken()
          const response = await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          this.elements = response.data

          this.loading= false
        } catch (e) {
          this.$router.push("/login")
          console.error(e)
          this.loading = false  
        }
      },
      selectItem(item){
        this.$router.push(this.$route.path+'?device='+this.device.name+'&element='+item.name)
        //this.placementDetailsVisible =  true
        //this.elementId = item.elementId
      },
      back(){
        this.$router.push('/management/'+this.page.siteId + '/pages');
      }
    }

  }
</script>